import { render, staticRenderFns } from "./card-bs.vue?vue&type=template&id=2331732e&"
import script from "./card-bs.vue?vue&type=script&lang=js&"
export * from "./card-bs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2331732e')) {
      api.createRecord('2331732e', component.options)
    } else {
      api.reload('2331732e', component.options)
    }
    module.hot.accept("./card-bs.vue?vue&type=template&id=2331732e&", function () {
      api.rerender('2331732e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/container/card-bs.vue"
export default component.exports